import sumoLogo from '../images/sumo_logo.png'
import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Input } from '../components/input'
import { AuthLayout } from '../components/auth-layout'
import { Loader } from '../components/loader'
import config from '../config.js'

import { Avatar } from '../components/avatar'
import { Button } from '../components/button'
import { Checkbox, CheckboxField } from '../components/checkbox'
import { ErrorMessage, Field, Label } from '../components/fieldset'
import { Heading } from '../components/heading'
import { Select } from '../components/select'
import { Strong, Text, TextLink } from '../components/text'

import { ErrorNotification, SuccessNotification } from '../components/notification';
import { useAlert } from "../components/customAlert";
import ValidationErrors from "../components/validationErrors";

export default function AccountSetupRegistration() {
	const { showAlert } = useAlert();
	const [formData, setFormData] = useState({ company_name: '', display_name: '', user_email: '', passwd: '', verify_passwd: '' });
	const [errors, setErrors] = useState({});
	const [serverError, setServerError] = useState('');
    const [isChecking, setIsChecking] = useState(true);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
	const [errorMsg, setErrorMsg] = useState('');
  	const [showErrorBox, setShowErrorBox] = useState(false);
	const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/; 
	
	function useQuery() {
		return new URLSearchParams(useLocation().search);
	}

	const query = useQuery();
	const page = query.get('is_agency');
	const validate = () => {
		const newErrors = {};
		
		if (!formData.display_name || formData.display_name.trim() === "") {
			newErrors.display_name = 'Name is required';
        }

		if (!formData.email) {
			newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
			newErrors.email = 'Please enter valid Email';
        }	
		
		if (!formData.passwd) {
			newErrors.passwd = 'Password is required';
        }else if (!strongPasswordRegex.test(formData.passwd)) {
  			newErrors.passwd = "Password must be at least 8 characters, \ninclude upper & lower case letters, \na number, and a special character";
		}
		
		if (!formData.verify_passwd) {
			newErrors.verify_passwd = 'Verify password is required';
        }else if (formData.passwd != formData.verify_passwd) {
			newErrors.verify_passwd = 'Both password fields must match';
        }		
		
		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
    };
	const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        //setErrors(prev => ({ ...prev, [name]: '' }));
        setServerError('');
    };
	const handleSubmit = async (e) => {
        e.preventDefault(); // prevent page reload
        if (!validate()) return;
         try {
            setLoading(true);
            const response = await fetch(`${config.apiPath}/account-setup/account-handler.php?process=merchant_reg`, {
                method: 'POST',
				        credentials: 'include',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            console.log('Server response:', result);
            if (result.status === 'success') {                
				navigate('/link-google-account', { state: { gmcEmail: formData.email } });
            } else {
				setLoading(false);
               showAlert('Merchant account already exists for given email', "Error" , "error",3000);			    
            }
            			
        } catch (err) {
				setLoading(false);
				showAlert('Unable to process your request, please try again later', "Error" , "error",3000);
        }
    };
  return (

<AuthLayout>
	<div className="w-full flex justify-center">
    <div className="w-full max-w-md">
	<ErrorNotification showErrorBox={showErrorBox} errorMsg={errorMsg} setShowErrorBox={setShowErrorBox} />
	<form action="#" noValidate onSubmit={handleSubmit} method="POST" className="grid grid-cols-1 gap-x-8 gap-y-2 !align-center !content-center w-full">
		<div className="flex justify-center"><Avatar square className="!size-20" src={sumoLogo} /></div>
		<Heading className="text-center !text-4xl py-1">Welcome to FeedSumo</Heading>
		<Heading className="text-center !text-1xl py-1">Let's get you started</Heading>
		<Heading className="text-center !text-1xl pt-1 pb-2">Great - you're setting up an individual account</Heading>

		<div className="w-full">
			{Object.values(errors).length > 0 && (
				<ValidationErrors 
				title="There were some errors with your submission" 
				errors={Object.values(errors)} 
				/>
			)}
		</div>

		<Field>
			<Label>What is your name</Label>
			<Input type="text" name="display_name" value={formData.display_name} onChange={handleChange}/>
			{/*errors.display_name ? <p className="text-red-500 text-sm mt-1">{errors.display_name}</p> : <p className="text-red-500 text-sm mt-1">&nbsp;</p>*/}
			<p className="text-red-500 text-sm mt-1">&nbsp;</p>
		</Field>
		<Field>
			<Label>Provide your Google Merchant Center email</Label>
			<Input type="email" name="email" value={formData.email} onChange={handleChange}/>
			{/*errors.email ? <p className="text-red-500 text-sm mt-1">{errors.email}</p> : <p className="text-red-500 text-sm mt-1">&nbsp;</p>*/}
			<p className="text-red-500 text-sm mt-1">&nbsp;</p>
		</Field>
		<Field>
			<Label>Set your password</Label>
			<Input type="password" name="passwd" autoComplete="new-password" value={formData.passwd} onChange={handleChange}/>
			{/*errors.passwd ? <p className="text-red-500 text-sm mt-1  whitespace-pre-line">{errors.passwd}</p> : <p className="text-red-500 text-sm mt-1">&nbsp;</p>*/}
			<p className="text-red-500 text-sm mt-1">&nbsp;</p>
		</Field>
		<Field>
			<Label>Verify your password</Label>
			<Input type="password" name="verify_passwd" autoComplete="new-password" value={formData.verify_passwd} onChange={handleChange}/>
			{/*errors.verify_passwd ? <p className="text-red-500 text-sm mt-1">{errors.verify_passwd}</p> : <p className="text-red-500 text-sm mt-1">&nbsp;</p>*/}
			<p className="text-red-500 text-sm mt-1">&nbsp;</p>
		</Field>
		<Button type="submit" id="create_account" className="text-center">Create account</Button>
	</form>
	</div>
	</div>
</AuthLayout>

);
}